import {
    GET_PRODUCTION_LIST_PROGRESS, GET_PRODUCTION_LIST_SUCCESS, GET_PRODUCTION_LIST_FAILURE,
    ADD_PRODUCTION_PROGRESS, ADD_PRODUCTION_SUCCESS, ADD_PRODUCTION_FAILURE,
    EDIT_DELETE_PRODUCTION_PROGRESS, EDIT_DELETE_PRODUCTION_SUCCESS, EDIT_DELETE_PRODUCTION_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    production: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const production_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRODUCTION_LIST_SUCCESS:
            return { ...state, production: action.production, loading: false };
        case GET_PRODUCTION_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PRODUCTION_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_PRODUCTION_PROGRESS:
            return { ...state, loading: true };
        case ADD_PRODUCTION_SUCCESS:
            return { ...state, production: [...state.production, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_PRODUCTION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_PRODUCTION_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_PRODUCTION_SUCCESS:
            return {
                ...state,
                production: state.production.map((production) =>
                    production.id === action.payload.id ? action.payload : production
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_PRODUCTION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };


        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default production_reducer;